"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lab = require("@mui/lab");
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StatusTimeline = _ref => {
  let _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? [] : _ref$steps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.Timeline, {
    position: "right",
    sx: {
      p: 0,
      m: 0,
      ["& .MuiTimelineItem-root:before"]: {
        flex: 0,
        padding: 0
      },
      // LEFT ALIGN FIX
      '& *': {
        fontFamily: 'Inter'
      }
    },
    children: steps.map((step, index) => {
      var _step$renderContent;
      const isLast = index === steps.length - 1;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_lab.TimelineItem, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_lab.TimelineSeparator, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 24,
              marginTop: '0.75rem'
            },
            children: step.icon
          }), !isLast && /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.TimelineConnector, {
            sx: {
              minHeight: 46,
              backgroundColor: '#CFC8FF'
            }
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.TimelineContent, {
          sx: {
            p: '12px'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
            children: [step.showDetails ? (_step$renderContent = step.renderContent) === null || _step$renderContent === void 0 ? void 0 : _step$renderContent.call(step) : step.placeholder, step.dateTime && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
              textAlign: "right",
              mt: 1,
              fontSize: 10,
              color: "text.secondary",
              children: step.dateTime
            })]
          })
        })]
      }, step.key || index);
    })
  });
};
var _default = exports.default = StatusTimeline;